import { useRef, useEffect } from 'react';
/* eslint-disable consistent-return */

/*
A React hook to use with add/remove event listeners.

Example usage

  import { useState } from 'react';

  const useMouseMove = () => {
    const [coords, setCoords] = useState([0, 0]);
    useEventListener('mousemove', ({ clientX, clientY }) => {
      setCoords([clientX, clientY]);
    });
    return coords;
  };

  export default useMouseMove;
*/

var useEventListener = function useEventListener(eventName, handler) {
  var element = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : global;
  var savedHandler = useRef();
  useEffect(function () {
    savedHandler.current = handler;
  }, [handler]);
  useEffect(function () {
    var isSupported = element && element.addEventListener;
    if (!isSupported) return;

    var eventListener = function eventListener(event) {
      return savedHandler.current(event);
    };

    element.addEventListener(eventName, eventListener);
    return function () {
      element.removeEventListener(eventName, eventListener);
    };
  }, [eventName, element]);
  return {
    eventName: eventName,
    handler: handler,
    element: element
  };
};

export default useEventListener;